import 'product/trending'
